import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Login from './features/auth/components/Login';
import Signup from './features/auth/components/Signup';
import ProtectedRoute from './features/auth/components/ProtectedRoute';
import AppLayout from './components/layout/AppLayout';
import SharedLayout from './components/layout/SharedLayout';
import { AuthProvider } from './contexts/AuthContext';

// Import Pages
import Home from './pages/Home';
import CreateStory from './pages/CreateStory';
import MyStories from './pages/MyStories';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import SharedStory from './pages/SharedStory';
import StoryView from './pages/StoryView';
import StoryWorkshop from './pages/StoryWorkshop';

// Import styles
import './styles/App.css';

/**
 * Main App component with routing configuration
 */
function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/shared/:shareCode" element={
            <SharedLayout>
              <SharedStory />
            </SharedLayout>
          } />
          
          {/* Protected Routes - All wrapped in AppLayout */}
          <Route path="/app" element={
            <ProtectedRoute>
              <AppLayout>
                <Home />
              </AppLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/create-story" element={
            <ProtectedRoute>
              <AppLayout>
                <CreateStory />
              </AppLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/my-stories" element={
            <ProtectedRoute>
              <AppLayout>
                <MyStories />
              </AppLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/story/:id" element={
            <ProtectedRoute>
              <AppLayout>
                <StoryView />
              </AppLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/profile" element={
            <ProtectedRoute>
              <AppLayout>
                <Profile />
              </AppLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/settings" element={
            <ProtectedRoute>
              <AppLayout>
                <Settings />
              </AppLayout>
            </ProtectedRoute>
          } />
          
          <Route path="/workshop" element={
            <ProtectedRoute>
              <AppLayout>
                <StoryWorkshop />
              </AppLayout>
            </ProtectedRoute>
          } />
          
          {/* Fallback Route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
